import React from "react";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Container,
    Grid,
    Typography,
} from "@mui/material";

import Planner from "./Planner";
import BreadcrumbBuilder from "../BreadcrumbBuilder";

const Calendar = () => {
    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <Card className="card">
                        <CardHeader
                            disableTypography={true}
                            title={
                                <Typography component="h2" variant="h2">
                                    Calendar
                                </Typography>
                            }
                        />
                        <CardContent>
                            <Box className="card-content">
                                <Planner />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Calendar;
